import React from "react";

const Introduction = () => {
  return (
    <section id="introduction">
      <div className="container">
        <div className="row row-header">
          <h4>INTRODUCTION</h4>
        </div>
        <div className="how-section1">
          <div className="row">
            <div className="col-md-9">
              <h4>
                <img
                  src={window.location.origin + "/images/Bag.png"}
                  className="row-img"
                  alt="BAGS"
                />{" "}
                BAGS
              </h4>
              <h4 className="subheading">PREMIUM ALLERGEN FILTRATION</h4>
              <p className="small">EFFECTIVELY TRAP</p>
              <p className="text-muted">
                Household fibers grass pollens ragweed pollens dust mid debris
                pet dander.
              </p>
              <h5>Benefits of Vacuum Bags </h5>
            </div>
            <div className="col-md-3 text-left">
              <img
                src={window.location.origin + "/images/b1.png"}
                className="img-fluid"
                alt="Bag"
              />
            </div>
          </div>
        </div>
        <div className="flex-row row">
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b2.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Less Maintenance</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      When the bag gets full, just remove it from the vacuum and
                      throw it away.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b3.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Hygienic</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      Keep dirt and debris contained in the bag prevent it from
                      entering back into the air.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b4.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Easy to Use</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      Bagged vacuums typically don't need to be empted as often
                      and it is easy to change a bag once full
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b10.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Febreze&reg; Scented</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      Eliminato odors and freshen as you vacuum
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="hr-style" />
        <div className="how-section1">
          <div className="row">
            <div className="col-md-9">
              <h4>
                <img
                  src={window.location.origin + "/images/Filters.png"}
                  className="row-img"
                  alt="FILTERS"
                />{" "}
                FILTERS
              </h4>
              <h4 className="subheading">
                MAXIMIZE VACUUM PERFORMANCE &Aacute; EXTEND VACUUM LIFE
              </h4>
              <p className="small">Clean filters help</p>
              <p className="text-muted">
                <br />
              </p>
              <h5>Benefits of Filters </h5>
            </div>
            <div className="col-md-3 text-left">
              <img
                src={window.location.origin + "/images/b6.png"}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="flex-row row">
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b7.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Performance</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      Filters help to maximize performance and extend the file
                      of your vacuum
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b8.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Convenience</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      No need to hassle with buying and storing bags. The vacuum
                      is ready to use anytime you are ready to clean.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b9.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Easy to Use</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      You can see when the tank is full, so you know it is time
                      to empty the tank and check your filters.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/b10.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Febreze&reg; Scented</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      Eliminato odors and freshen as you vacuum
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Introduction;
